module.exports = __webpack_public_path__ + "img/cursor_right.73d778df.png";